const reportWebVitals = (onPerfEntry?: Function) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
      onCLS((metric) => onPerfEntry(metric));
      onFID((metric) => onPerfEntry(metric));
      onFCP((metric) => onPerfEntry(metric));
      onLCP((metric) => onPerfEntry(metric));
      onTTFB((metric) => onPerfEntry(metric));
    });
  }
};

export default reportWebVitals;
